import { co2Slice } from "../../reducers/reservation/co2Reducer";

export const { updateCo2Dict, resetCo2Dict } = co2Slice.actions;
